import {Box, FormControl, Grid, InputLabel, Select} from "@mui/material"
import MenuItem from '@mui/material/MenuItem'
import React, {useState} from "react"
import LayoutPage from "src/components/page-layout/layout-page"
import {parameterDatalakeTableList} from "./parameter-datalake-data"
import AlertMessage from "../../../components/alert-message"

const ParameterDatalakePage = () => {
    const [tableSelected, setTableSelected] = useState("")
    const [loading, setLoading] = useState(false)
    const [selectedComponent, setSelectedComponent] = useState(null)
    const [alertMessageState, setAlertMessageState] = React.useState({
        open: false,
        message: "",
        type: "info"
    })

    const setTable = (event) => {
        const table = event.target.value
        setTableSelected(table)
        if (!table) return
        const {endpoint, component, app, model} = parameterDatalakeTableList.find(item => item.key === table)
        const Comp = component
        const SelectedComponent = (
            <Comp
                endpoint={`${endpoint}?app=${app}&model=${model}`}
                loading={setLoading}
                callbackError={openLAlertError}
            />
        )
        setSelectedComponent(SelectedComponent)
    }

    const openLAlertError = (error) => {
        console.log(error)
        openAlert("Não foi possível carregar os dados.", "error")
    }

    const openAlert = (message, type) => {
        setAlertMessageState({
            ...alertMessageState,
            open: true,
            message: message,
            type: type
        })
    }

    return (
        <LayoutPage title="Parâmetros" loading={loading}>
            <AlertMessage open={alertMessageState.open} message={alertMessageState.message} type={alertMessageState.type} close={() => setAlertMessageState({ ...alertMessageState, open: false })} />
            <Box sx={{mx: 2, width: 'auto'}}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={4} xl={4}>
                        <FormControl variant="standard" fullWidth>
                            <InputLabel id="select-tabela">Selecione a Tabela Para Consulta</InputLabel>
                            <Select
                                fullWidth
                                labelId="select-tabela"
                                id="select-tabela-id"
                                value={tableSelected}
                                label="Selecione a Tabela Para Consulta"
                                onChange={setTable}
                            >
                                {
                                    parameterDatalakeTableList
                                        .sort((a, b) => a.label.localeCompare(b.label))
                                        .map((item) => {
                                            return (
                                                <MenuItem key={item.key} value={item.key}
                                                          disabled={item.disable || false}>
                                                    {item.label}
                                                </MenuItem>
                                            )
                                        })
                                }
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={12}>
                        {selectedComponent}
                    </Grid>
                </Grid>
            </Box>
        </LayoutPage>
    )
}

export default ParameterDatalakePage

